import React from 'react';
import { HStack, useToast as useNativeToast } from 'native-base';
import { Caption } from '~/shared/Typography';
import { SpIcon } from '~/shared/Icon';
import { faCircleCheck, faXmarkCircle } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '@springbig/shared';

export const useToast = () => {

    const toast = useNativeToast();

    const {
        radius_md,
    } = useTheme();

    const successToast = (title: string, description?: string) => {

        const id = Math.random().toString(36).substring(7);

        toast.show({
            id,
            render: () => {

                return (
                    <HStack
                        bg={'success'}
                        px={'6'}
                        py={'3'}
                        rounded={radius_md}
                        justifyContent={'space-between'}
                        alignItems={'center'}
                        space={2}
                    >
                        <SpIcon color={'white'} icon={faCircleCheck} />
                        <Caption color={'white'}>
                            { title }
                        </Caption>
                        { description &&
                            <Caption ml={2} color={'white'}>
                                { description }
                            </Caption>
                        }
                    </HStack>
                );
            },
            placement: 'bottom',
            duration: 4000
        });
    };

    const errorToast = (title: string, description?: string) => {

        const id = Math.random().toString(36).substring(7);

        toast.show({
            id,
            render: () => {

                return (
                    <HStack
                        bg={'danger'}
                        rounded={radius_md}
                        justifyContent={'space-between'}
                        alignItems={'center'}
                        w={'clamp(320px, 100vw, 480px)'}
                        space={2}
                    >
                        <SpIcon color={'white'} icon={faXmarkCircle} />
                        <Caption color={'white'} noOfLines={2}>
                            { title }
                        </Caption>
                        { description &&
                            <Caption color={'white'}>
                                { description }
                            </Caption>
                        }
                    </HStack>
                );
            },
            placement: 'bottom',
            duration: 4000
        });
    };

    return {
        successToast,
        errorToast
    };
};
